"use client";

// src/responsive/StackBreakpointProvider.tsx
import { createContext } from "@teamsparta/stack-utils";
var [
  /**
   * @description BreakpointContext를 생성하는 Provider입니다.
   * @example <StackBreakpointProvider mobile={0} tablet={820} desktop={1024}>
   */
  StackBreakpointProvider,
  useBreakpointContext
] = createContext("BreakpointContextProvider", {
  mobile: 0,
  tablet: 768,
  desktop: 1024
});

export {
  StackBreakpointProvider,
  useBreakpointContext
};
